import { useQuery } from "@vue/apollo-composable";
import { customerQuery } from "@/api/userApi.ts";
import { computed } from "vue";
import { useFragment } from "@/api/generated";
import { CustomerFragmentFragmentDoc } from "@/api/generated/graphql.ts";
import useAuthUser from "@/composables/useAuthUser.ts";
import type { WatchQueryFetchPolicy } from "@apollo/client/core/watchQueryOptions";

export function useCustomer() {
  const { authUser } = useAuthUser();
  const isCustomerLoggedIn = computed(() => !!authUser.value);

  const customerQueryOptions = computed(() => ({
    enabled: isCustomerLoggedIn.value,
    fetchPolicy: "cache-and-network" as WatchQueryFetchPolicy,
  }));
  const { result, loading, error, refetch } = useQuery(customerQuery, null, customerQueryOptions);
  const customer = computed(() => useFragment(CustomerFragmentFragmentDoc, result.value?.customer));
  const loadingFirstTime = computed(() => loading.value && !customer.value);

  return {
    customer,
    isCustomerLoggedIn,
    loadingFirstTime,
    loading,
    error,
    refetch,
  };
}
